import GeoObjectApi from '@/api/geoObject'
import store from '@/store/index'
import { getToolboxLayoutOfLayer } from '@/helper/GeoObjectLayoutHelper'
import Vue from 'vue'

class GeoObject {
  constructor (data) {
    this.isDeleted = false
    this.id = data.id
    this.typeId = null
    this.fieldLayoutId = null
    this.title = null
    this.objects = []
    this.loaded = false
    this.readonly = false
    this.lastEditor = null
    if (data.loaded === true) {
      this.update(data)
    }
    this.loadingPromise = this.init()
  }

  update (data) {
    for (let fieldName in data) {
      if (data.hasOwnProperty(fieldName)) {
        Vue.set(this, fieldName, data[fieldName])
      }
    }
  }

  async init () {
    if (!this.id || this.loaded) {
      return this
    }
    let response = await GeoObjectApi.get(this.id)
    for (let fieldName in response.data) {
      if (response.data.hasOwnProperty(fieldName)) {
        Vue.set(this, fieldName, response.data[fieldName])
      }
    }

    // ausnahme für verlinkungen
    let promises = []
    for (let i = 0; i < this.objects.length; i++) {
      promises.push(new GeoObject({ id: this.objects[i].id }).loadingPromise)
    }

    let data = await Promise.all(promises)
    for (let i = 0; i < data.length; i++) {
      // data[i].readonly = true
      this.objects[i] = data[i]
    }
    // _.merge(this, response.data)
    this.loaded = true
    return this
  }

  getIdentifier () {
    return this.title
  }

  getLayer () {
    if (!this.layer) {
      return null
    }

    return store.getters['layer/get'](this.layer)
  }

  delete () {
    return GeoObjectApi.delete(this.id).then((result) => {
      this.isDeleted = true
      return result
    })
  }

  getToolboxTabs () {
    return getToolboxLayoutOfLayer(this.typeId, this.objects)
  }
}

export default GeoObject
